import { render } from "./Salesforce.vue?vue&type=template&id=737f4248&scoped=true&lang=pug"
import script from "./Salesforce.js?vue&type=script&lang=js&external"
export * from "./Salesforce.js?vue&type=script&lang=js&external"

import "./Salesforce.vue?vue&type=style&index=0&id=737f4248&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737f4248"]])

export default __exports__